'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircleBoxStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = function style(_ref) {
  var themeFromProvider = _ref.theme,
      customDiameter = _ref.customDiameter;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var diameter = theme.reactackle.components.progress.circle.diameter;


  return (0, _styledComponents.css)(['width:', ';height:', ';'], (0, _reactackleCore.getValueString)(customDiameter || diameter), (0, _reactackleCore.getValueString)(customDiameter || diameter));
};

var rotateAnimation = function rotateAnimation(_ref2) {
  var themeFromProvider = _ref2.theme,
      indeterminate = _ref2.indeterminate;

  var animationConfig = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider).reactackle.components.progress.circle.animation.svg;

  var duration = animationConfig.transitionDuration;


  var animation = (0, _styledComponents.keyframes)(['100%{transform:rotate(360deg);}']);

  return !indeterminate ? null : (0, _styledComponents.css)(['animation:', 'ms ', ' linear infinite;'], duration, animation);
};

var CircleBoxStyled = exports.CircleBoxStyled = _styledComponents2.default.svg.withConfig({
  displayName: 'CircleBoxStyled'
})(['margin:auto;border-radius:50%;display:block;max-width:100%;max-height:100%;', ' ', ''], rotateAnimation, style);

CircleBoxStyled.displayName = 'CircleBoxStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-progress/dist/CircleProgress/styles/CircleBoxStyled.js
// module id = 758
// module chunks = 0